export enum ScopeEnum {
  ARCHIVED = "archived",
  CUSTOMER_DETAILS = "customerDetails",
  INTERNAL_POLICY = "internal-policy",
  CUSTOMERS_LIST = "customerList",
  PERSONS_LIST = "persons",
  COMPANIES_LIST = "companies",
  ADVERSE_MEDIA_LIST = "adverse-media",
  SANCTIONS_LIST = "sanctions",
  POLITICAL_INVOLVEMENTS_LIST = "political-involvements"
}
